import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MenuItem } from '@web/shared/ui';

@Component({
  selector: 'app-header-desktop-menu-item',
  imports: [],
  templateUrl: './header-desktop-menu-item.component.html',
  styleUrl: './header-desktop-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderDesktopMenuItemComponent {
  public readonly item = input.required<MenuItem>();
}
